// extracted by mini-css-extract-plugin
export default {"medium":"Spacer_medium__JKWjS","small":"Spacer_small__Y6DSH"};